import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  CardActions,
  Button,
} from "@mui/material";
import Section from "./Section.jsx";
import { ReactComponent as LogoSvg } from "../assets/logo.svg";
import { ReactComponent as LogoGoldSvg } from "../assets/logo-gold.svg";
import { ReactComponent as FeatherSvg } from "../assets/feather.svg";
import { ReactComponent as LeafSvg } from "../assets/leaf2.svg";
import PaletteIcon from "@mui/icons-material/Palette";
import WineBarIcon from "@mui/icons-material/WineBar";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import DiamondIcon from "@mui/icons-material/Diamond";

const parchmentTextStyles = {
  textAlign: "justify",
  fontSize: "1.15rem",
  lineHeight: 1.9,
  color: "#4a2c1a",
  fontStyle: "italic",
  letterSpacing: "0.2px",
  fontFamily: `"Cormorant Garamond", serif`,
  textShadow: "0 1px 1px rgba(255,255,255,0.3)",
  textIndent: "30px",
};

const highlightTextStyles = {
  color: "#6d4420",
  fontWeight: 600,
  textShadow: "0 1px 1px rgba(255, 255, 255, 0.25)",
};
export const reviews = [
  {
    description: (
      <Box>
        <Typography sx={parchmentTextStyles}>
          Після місяців ремонту здавалося, що пил та хаос стали частиною мого
          життя. Але разом із Вашим візитом з дому пішла і вся втома. Я вперше
          за довгий час відчула справжню{" "}
          <Typography sx={highlightTextStyles} variant="span">
            красу у власному домі.
          </Typography>
        </Typography>
        <Typography sx={parchmentTextStyles}>
          Це не просто післяремонтне прибирання - це{" "}
          <Typography sx={highlightTextStyles} variant="span">
            повернення до себе.
          </Typography>{" "}
          Дякую за цей стан досконалості та за Ваше{" "}
          <Typography sx={highlightTextStyles} variant="span">
            ювелірне ставлення
          </Typography>{" "}
          до кожної нової поверхні. І, особливо дякую Вам за неймовірний
          комплімент...
          <FeatherSvg
            style={{
              marginLeft: "10px",
              width: "24px",
              height: "24px",
              opacity: 0.6,
              pointerEvents: "none",
            }}
          />
        </Typography>
      </Box>
    ),
    author: "Віолетта, Ужгород",
    width: "100%",
    Icon: LogoSvg,
  },
  {
    description: (
      <Box>
        <Typography sx={parchmentTextStyles}>
          Ви подарували мені справжнє свято. Зайти в дім, де пахне аромат
          свіжості, а не пилу - це безцінно. Післяремонтне прибирання від Вас -
          це найкраще рішення для мене. Дякую Вам.
        </Typography>
      </Box>
    ),
    author: "Марія, Ужгород",
    width: "90%",
    Icon: LogoGoldSvg,
  },
  {
    description: (
      <Box>
        <Typography sx={parchmentTextStyles}>
          Це був мій перший досвід з професійним сервісом. Раніше я завжди дбала
          про дім сама. Але те, що зробили Ви - це інший рівень свідомості.
        </Typography>
        <Typography sx={parchmentTextStyles}>
          Найбільшим відкриттям стало те, як почали{" "}
          <Typography sx={highlightTextStyles} variant="span">
            дихати стіни та стеля
          </Typography>{" "}
          після знепилення, скільки невидимого пилу забирало наше повітря. Така{" "}
          <Typography sx={highlightTextStyles} variant="span">
            невагома легкість дихання
          </Typography>{" "}
          та чистота кожної деталі...
        </Typography>
        <Typography sx={parchmentTextStyles}>
          <Typography sx={highlightTextStyles} variant="span">
            Справжня гармонія
          </Typography>{" "}
          починається там, де працює професіонал. Дякую за це відкриття.
        </Typography>
      </Box>
    ),
    author: "Надія, Ужгород",
    width: "90%",
    Icon: LogoGoldSvg,
  },
];
export default function Reviews() {
  return (
    <Section
      id="reviews"
      title="Враження"
      headerStyles={{
        color: "#5f2e20",
        textDecoration: "underline",
        textDecorationColor: "#ffd700",

        ":after": { display: "none" },
      }}
    >
      <Grid
        container
        spacing={3}
        sx={{
          justifyContent: "left",
          alignItems: "top",
          width: "100%",
        }}
        padding={2}
      >
        <Typography
          variant="h6"
          sx={{
            textAlign: "center",
            width: "100%",
            color: "#ffd700",
            fontWeight: "100",
          }}
        >
          Ваша довіра - наше головне натхнення.
        </Typography>
        {reviews.map((review) => {
          const { Icon } = review;
          return (
            <Grid
              key={review.author}
              container
              sx={{ width: "100%", justifyContent: "center" }}
            >
              <Card
                sx={{
                  width: review.width,
                  position: "relative",
                  p: 2,
                  borderRadius: "6px",
                  overflow: "hidden",

                  background:
                    "radial-gradient(circle at left top, rgba(255, 255, 255, 0.35), transparent 35%), radial-gradient(circle at right bottom, rgba(120, 80, 40, 0.18), transparent 40%), linear-gradient(rgb(248, 236, 208) 0%, rgb(241, 223, 184) 100%)",
                  border: "1px solid rgba(120,80,40,0.35)",

                  boxShadow: `
      0 12px 30px rgba(0,0,0,0.18),
      inset 0 0 40px rgba(120,80,40,0.12),
      inset 0 0 8px rgba(255,255,255,0.5)
    `,

                  transform:
                    review.author === "Марія, Ужгород"
                      ? "rotate(0.6deg)"
                      : review.author === "Надія, Ужгород"
                        ? "rotate(-0.7deg)"
                        : "rotate(-0.3deg)",

                  transition: "0.35s ease",

                  "&:hover": {
                    transform: "rotate(0deg) scale(1.015)",
                  },

                  "&::before": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    opacity: 0.18,
                    pointerEvents: "none",

                    backgroundImage: `
        repeating-linear-gradient(
          0deg,
          transparent,
          transparent 3px,
          rgba(120,80,40,0.04) 4px
        ),
        repeating-linear-gradient(
          90deg,
          transparent,
          transparent 2px,
          rgba(255,255,255,0.03) 3px
        )
      `,
                  },

                  "&::after": {
                    content: '""',
                    position: "absolute",
                    inset: "8px",
                    border: "1px solid rgba(120,80,40,0.15)",
                    pointerEvents: "none",
                  },
                }}
              >
                <CardContent sx={{ textAlign: "left", p: 3 }}>
                  <Grid>
                    <Box
                      sx={{
                        fontSize: "1.15rem",
                        lineHeight: 1.9,
                        color: "#4a2c1a",
                        fontStyle: "italic",
                        letterSpacing: "0.2px",
                        fontFamily: `"Cormorant Garamond", serif`,
                        textShadow: "0 1px 1px rgba(255,255,255,0.3)",
                      }}
                    >
                      {review.description.props.children}
                    </Box>

                    <Typography
                      sx={{
                        textAlign: "right",
                        mt: 3,
                        fontSize: "1.15rem",
                        color: "#8b5a2b",
                        fontFamily: `"Cormorant Garamond", serif`,
                        fontStyle: "italic",
                        letterSpacing: "1px",
                      }}
                    >
                      — {review.author}
                    </Typography>
                  </Grid>
                </CardContent>

                <Icon
                  style={{
                    position: "absolute",
                    bottom: "10px",
                    right: "10px",
                    width: "24px",
                    height: "24px",
                    opacity: 0.6,
                    pointerEvents: "none",
                  }}
                />
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Section>
  );
}
